/**
 * Sound utility for task completion feedback.
 *
 * Carica `spunta_chime.wav` una volta sola (preload), riproduce solo quando
 * l'utente passa un item a "fatto" (non sulla despunta), volume 0.3, rispetta
 * il toggle mute nelle Impostazioni.
 *
 * - playCheckSound(): chiamare solo nella transizione false → true
 * - isMuted() / setMuted(b): persistita in localStorage
 */

const STORAGE_KEY = 'qp.sound.muted';
const CHIME_URL = 'https://customer-assets.emergentagent.com/job_cascade-planner/artifacts/3ok6ik40_spunta_chime.wav';
const VOLUME = 0.3;

export function isMuted() {
  try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; /* localStorage disabilitato → assume non muto */ }
}

export function setMuted(b) {
  try { localStorage.setItem(STORAGE_KEY, b ? '1' : '0'); } catch { /* localStorage pieno/disabilitato: pref non persistita ma non blocca */ }
  try { window.dispatchEvent(new CustomEvent('qp:sound-muted-change', { detail: b })); } catch { /* CustomEvent non supportato (ambienti SSR/test): non critico */ }
}

// Preload una sola volta (singleton)
let _audio = null;
function getAudio() {
  if (_audio) return _audio;
  if (typeof Audio === 'undefined') return null;
  _audio = new Audio(CHIME_URL);
  _audio.preload = 'auto';
  _audio.volume = VOLUME;
  // Avvia il fetch della risorsa
  try { _audio.load(); } catch { /* alcuni browser bloccano load() fino a gesture: ok, parte al play() */ }
  return _audio;
}

// Inizializza alla prima import
if (typeof window !== 'undefined') {
  getAudio();
}

/**
 * Riproduce il chime — solo quando passa a fatto. Crea sempre una copia clonata
 * dal singleton precaricato così suoni rapidi consecutivi non si troncano.
 */
export function playCheckSound() {
  if (isMuted()) return;
  const base = getAudio();
  if (!base) return;
  try {
    const sound = base.cloneNode();
    sound.volume = VOLUME;
    const p = sound.play();
    if (p && typeof p.catch === 'function') {
      p.catch(() => { /* autoplay bloccato finché non c'è gesture: ok */ });
    }
  } catch { /* play() può fallire prima che il file sia caricato o se l'utente non ha ancora interagito: ok */ }
}
